module.exports = __webpack_public_path__ + "img/build1005.9385f395.png";